import { Table, TextTableCellOwnProps } from 'evergreen-ui';
import React from 'react';

type Props = TextTableCellOwnProps & {
    children: React.ReactNode;
};

export function TableRowCell({children, ...cellProps}: Props) {
    return (
        <Table.TextCell {...cellProps}>
            <span className='text-base'>
                {children}
            </span>
        </Table.TextCell>
    );
}